import { type ReactNode } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  type DialogProps,
  DialogTitle,
  IconButton,
  Stack,
} from '@mui/material';
import { X } from 'lucide-react';

interface ModalProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
  /** Footer actions (buttons). */
  actions?: ReactNode;
  /** Dialog width. Defaults to the compact create-flow size. */
  maxWidth?: DialogProps['maxWidth'];
}

/** Lightweight, dependency-free modal dialog used for admin create flows. */
export function Modal({
  title,
  onClose,
  children,
  actions,
  maxWidth = 'sm',
}: ModalProps) {
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth={maxWidth} aria-label={title}>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 1,
        }}
      >
        {title}
        <IconButton onClick={onClose} aria-label="Close" size="small">
          <X size={16} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {children}
        </Stack>
      </DialogContent>
      {actions && (
        <DialogActions sx={{ px: 3, py: 2 }}>{actions}</DialogActions>
      )}
    </Dialog>
  );
}
